import { render } from "./DocumentClassFieldsLayoutView.vue?vue&type=template&id=4b2f845d&scoped=true&ts=true"
import script from "./DocumentClassFieldsLayoutView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldsLayoutView.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldsLayoutView.vue?vue&type=style&index=0&id=4b2f845d&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f845d"]])

export default __exports__